import { getHttpClient } from '../lib/http-client';

const reportFilePath = (id: string) => `/admin/reports/report_files/${id}`;

export const fetchMarkReportFile = async (id: string) => {
	const http = await getHttpClient();
	return (await http.patch<{ success: boolean }>(reportFilePath(id))).data;
};
